import { Component } from '@angular/core';

@Component({
  selector: 'app-settings',
  standalone: false,
  styleUrl: './settings.css',
  templateUrl: './settings.html',
})
export class Settings {}
